import { Controller } from "@hotwired/stimulus"
import moment from "moment"

export default class extends Controller {
  static targets = ["input", "form"]
  static values = { today: String }

  connect() {
    this.initPicker()
    this.highlightActiveFilter()
  }

  disconnect() {
    this.picker?.remove()
    this.picker = null
  }

  initPicker() {
    // El calendario también debe partir de la jornada del servidor.
    if (!this.inputTarget.value && this.hasTodayValue) {
      const today = this.today.format("DD-MM-YYYY")
      this.inputTarget.value = `${today} - ${today}`
    }

    if (this.inputTarget.readOnly) return

    this.picker = new DateRangePicker(this.inputTarget, {
      locale: {
        format: "DD-MM-YYYY",
        firstDay: 1,
        daysOfWeek: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
        monthNames: [
          "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
          "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ],
      },
      autoApply: true,
    }, (start, end) => {
      this.inputTarget.value = `${start.format("DD-MM-YYYY")} - ${end.format("DD-MM-YYYY")}`
      this.highlightActiveFilter()
    })
  }

  applyRange(event) {
    const button = event.currentTarget
    const offset = parseInt(button.dataset.offset)
    const unit = button.dataset.unit

    const start = this.today.subtract(offset, unit).format("DD-MM-YYYY")
    const end = this.today.format("DD-MM-YYYY")

    this.picker?.setStartDate(start)
    this.picker?.setEndDate(end)
    this.inputTarget.value = `${start} - ${end}`
    this.highlightActiveFilter()
    this.formTarget.requestSubmit()
  }

  highlightActiveFilter() {
    this.quickFilterButtons.forEach(btn => {
      btn.classList.remove("active")
      btn.setAttribute("aria-pressed", "false")
    })

    const currentValue = this.inputTarget.value
    let daysDiff

    if (!currentValue) {
      // Sin param → el backend default es hoy (start = end = today).
      daysDiff = 0
    } else {
      const [startStr, endStr] = currentValue.split(" - ")
      if (!startStr || !endStr) return

      const start = moment(startStr, "DD-MM-YYYY")
      const end = moment(endStr, "DD-MM-YYYY")
      const today = this.today

      // Only match if end date is today
      if (!end.isSame(today, "day")) return

      daysDiff = today.diff(start, "days")
    }

    this.quickFilterButtons.forEach(btn => {
      const offset = parseInt(btn.dataset.offset)
      const unit = btn.dataset.unit

      let expectedDiff
      if (unit === "days") {
        expectedDiff = offset
      } else if (unit === "months") {
        expectedDiff = this.today.diff(this.today.subtract(offset, "months"), "days")
      }

      if (daysDiff === expectedDiff) {
        btn.classList.add("active")
        btn.setAttribute("aria-pressed", "true")
      }
    })
  }

  get quickFilterButtons() {
    return this.element.querySelectorAll(".quick-filter-btn")
  }

  // Los reportes reciben la jornada del servidor; otras vistas (reembolsos)
  // que comparten este controller conservan su comportamiento calendario.
  get today() {
    return this.hasTodayValue ? moment(this.todayValue, "YYYY-MM-DD", true) : moment().startOf("day")
  }
}
